import app from 'flarum/app';
import addTextOnDiscussionPost from './addTextOnDiscussionPost';

app.initializers.add('hyperactiveknight/flarum-ext-stars', () => {
  console.log('Hello, forum!');
  console.log('This stuff is working!');

  addTextOnDiscussionPost();
  
});